export const ORDER_STATUSES_REQUIRING_CANCEL_REASON = ['inProcess', 'packed', 'waitingForCarrier'] as const;

export const ORDER_CANCEL_STATUS = 'canceled';
export const RECEIVING_CANCEL_STATUS = 'canceled';
export const RETURN_CANCEL_STATUS = 'canceled';
export const CLAIM_CANCEL_STATUS = 'storno';

export function isCancelStatusChange(
    editStatus: string | undefined,
    isNew: boolean,
    cancelStatus: string
): boolean {
    return !isNew && editStatus === cancelStatus;
}

export function isOrderCancelReasonRequired(
    previousStatus: string | undefined,
    editStatus: string | undefined,
    existingCancelReason: string | null | undefined,
    permissionEditAll: boolean
): boolean {
    if (!permissionEditAll || editStatus !== ORDER_CANCEL_STATUS) {
        return false;
    }

    const fromStatusesRequiringReason = ORDER_STATUSES_REQUIRING_CANCEL_REASON.includes(
        previousStatus as (typeof ORDER_STATUSES_REQUIRING_CANCEL_REASON)[number]
    );

    return (
        (fromStatusesRequiringReason && editStatus === ORDER_CANCEL_STATUS) || !!existingCancelReason
    );
}

export function isEmptyCancelReason(cancelReason: string | null | undefined): boolean {
    return cancelReason == null || cancelReason === '';
}

export type OrderCancelPatchPayload = {
    ID: string;
    STATUS: typeof ORDER_CANCEL_STATUS;
    CANCEL_REASON?: string;
};

export type StatusCancelPatchPayload = {
    STATUS: string;
};

export function buildOrderCancelPatchPayload(
    idOrder: string,
    cancelReason?: string | null
): OrderCancelPatchPayload {
    const payload: OrderCancelPatchPayload = {
        ID: idOrder,
        STATUS: ORDER_CANCEL_STATUS,
    };

    if (!isEmptyCancelReason(cancelReason)) {
        payload.CANCEL_REASON = cancelReason as string;
    }

    return payload;
}

export function buildStatusCancelPatchPayload(cancelStatus: string): StatusCancelPatchPayload {
    return { STATUS: cancelStatus };
}
